import { registry } from '../registry';
import type { InvitationData, TemplateMetadata } from '../types';
import { WeddingPlotPlaneExperience } from './WeddingPlotPlaneExperience';

const META: TemplateMetadata = {
  id: 'exp-wedding-plot-plane-3d',
  name: '3D Plot Plane Motion',
  occasionType: 'WEDDING',
  description:
    'A scroll-driven WebGL journey through six wedding photographs — sangeet, mehndi, the henna portal, ring ceremony, havan, and saat pheras.',
  isPremium: true,
  tags: ['wedding', '3d', 'webgl', 'scroll', 'photography', 'sangeet', 'mehndi', 'pheras'],
  colorScheme: { primary: '#e8c872', accent: '#c2410c', bg: '#140a07' },
};

export function WeddingPlotPlane3D({ data }: { data: InvitationData }) {
  return <WeddingPlotPlaneExperience data={data} />;
}

registry.register({ metadata: META, component: WeddingPlotPlane3D });
